export default {
    parts: ['container', 'maxMessage'],
    baseStyle: {
        container: {
            gap: 0,
            width: 'fit-content'
        },
        maxMessage: {
            color: 'webTypo.textError',
            textStyle: 'bodyXsRegular',
            alignItems: 'flex-start',
            my: 2
        },
        btn: {
            width: {base: '44px', lg: 6},
            height: {base: '44px', lg: 6},
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        }
    }
}
